export const TOOLBAR_EXERCISES = 'tb.exercises';
export const TOOLBAR_TRAININGS = 'tb.trainings';